// Form.js

import { useState } from 'react';
import { Preferences, Features, RecommendationType } from './Fields';
import { SubmitButton } from './SubmitButton';
import useProducts from '../../hooks/useProducts';
import useForm from '../../hooks/useForm';
import useRecommendations from '../../hooks/useRecommendations';

function Form({ onRecommendationsUpdate }) {
  const { preferences, features, products } = useProducts();
  const { formData, handleChange } = useForm({
    selectedPreferences: [],
    selectedFeatures: [],
    selectedRecommendationType: '',
  });

  const { getRecommendations } = useRecommendations(products);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (
      formData.selectedPreferences.length === 0 &&
      formData.selectedFeatures.length === 0
    ) {
      newErrors.selections =
        'Selecione pelo menos uma preferência ou funcionalidade';
    }

    if (!formData.selectedRecommendationType) {
      newErrors.recommendationType = 'Selecione o tipo de recomendação';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setErrors({});

    const dataRecommendations = getRecommendations(formData);

    if (onRecommendationsUpdate) {
      onRecommendationsUpdate(dataRecommendations);
    }
  };

  return (
    <form className="space-y-6" onSubmit={handleSubmit}>
      <div className="border-b-2 border-rd-blue pb-4">
        <h2 className="text-2xl font-bold text-rd-navy">
          Configure suas preferências
        </h2>
        <p className="text-gray-600 text-sm mt-1">
          Selecione as opções que mais se adequam ao seu negócio
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Preferences
          preferences={preferences}
          onPreferenceChange={(selected) =>
            handleChange('selectedPreferences', selected)
          }
        />
        <Features
          features={features}
          onFeatureChange={(selected) =>
            handleChange('selectedFeatures', selected)
          }
        />
      </div>

      <div className="bg-gradient-to-r from-blue-50 to-cyan-50 p-6 rounded-xl border border-rd-cyan">
        <RecommendationType
          onRecommendationTypeChange={(selected) =>
            handleChange('selectedRecommendationType', selected)
          }
        />
      </div>

      {errors.selections && (
        <div className="p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded-r-lg">
          <div className="flex items-center">
            <span className="text-xl mr-2">⚠️</span>
            <span>{errors.selections}</span>
          </div>
        </div>
      )}
      {errors.recommendationType && (
        <div className="p-4 bg-red-50 border-l-4 border-red-500 text-red-700 rounded-r-lg">
          <div className="flex items-center">
            <span className="text-xl mr-2">⚠️</span>
            <span>{errors.recommendationType}</span>
          </div>
        </div>
      )}

      <div className="flex justify-center">
        <SubmitButton text="Obter recomendação" />
      </div>
    </form>
  );
}

export default Form;
